// @flow

import * as React from "react";
import queryString from "query-string";

import { PrimaryNavPad } from "../organisms/PrimaryNav";
import QuickSearch from "../molecules/QuickSearch";

import { ReactComponent as Triangle } from "../../../assets/images/shape-triangle.svg";
import { ReactComponent as Circle } from "../../../assets/images/shape-circle.svg";
import { ReactComponent as Ring } from "../../../assets/images/shape-ring-fill.svg";
import { ReactComponent as Diamond } from "../../../assets/images/shape-diamond.svg";

type PropsType = {};

const HeroSearch = (props: PropsType): React.Node => {
    const queryParamProps = queryString.parse(document.location.search);
    const baseClassName = "hero-search";
    const classes = [baseClassName];

    return (
        <div className={classes.join(" ")}>
            <PrimaryNavPad />

            <div className="hero-search__container container-fluid">
                <div className="container-fluid--medium">
                    {/* Design elements */}
                    <Circle className="hero-search__circle" />
                    <Ring className="hero-search__ring" />
                    <Triangle className="hero-search__triangle" />
                    <Diamond className="hero-search__diamond" />

                    <div className="hero-search__inner">
                        <h1 className="hero-search__heading">Search</h1>

                        <QuickSearch
                            defaultValue={queryParamProps.q}
                            inline={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSearch;
